import get from 'lodash.get';

const BRAND_CATALOG_SKU = 'THP000006';
const BRAND_CATALOG_SKU_WL = 'THP000006WL'; // Whitelabel SKU
const CAMPAIGN_CATALOG_SKU = 'THP000007';
const CAMPAIGN_CATALOG_SKU_WL = 'THP000007WL'; // Whitelabel SKU
const CAMPAIGN_CATALOG_SKU_SOLE_PROPRIETOR = 'THP000009';
const CAMPAIGN_CATALOG_SKU_SOLE_PROPRIETOR_WL = 'THP000009WL'; // Whitelabel SKU

const getDefaultPaymentMethod = (paymentMethods) => {
    return paymentMethods.find(paymentMethod => paymentMethod.defaultPmtMethod === true) || paymentMethods[0];
};

const getBrandCatalogRatePlanId = (catalogResponse) => {
    return catalogResponse.find(catalog => [BRAND_CATALOG_SKU_WL,BRAND_CATALOG_SKU].includes(catalog.sku));
};

const getCampaignCatalogRatePlanId = (catalogResponse, isSoleProprietor = false) => {
    if (isSoleProprietor) {
        return catalogResponse.find(catalog =>
            [CAMPAIGN_CATALOG_SKU_SOLE_PROPRIETOR_WL, CAMPAIGN_CATALOG_SKU_SOLE_PROPRIETOR].includes(catalog.sku)
        );
    }
    return catalogResponse.find(catalog =>
        [CAMPAIGN_CATALOG_SKU_WL, CAMPAIGN_CATALOG_SKU].includes(catalog.sku)
    );
};

const buildBillingObject = (accountDetails, accountId, isMultiLocationAccount, productRatePlanId, paymentMethodId ) => {
    const billingAddressObject =  {
        address1: accountDetails.Address1,
        address2: accountDetails.Address2,
        city: accountDetails.City,
        countryName: accountDetails.CountryId,
        jurisdictionCode: accountDetails.TaxJurisdictionCode,
        provinceName: get(accountDetails, 'ProvinceObject.ProvinceName', accountDetails.ProvinceName),
        provinceId: get(accountDetails, 'ProvinceObject.ProvinceId', accountDetails.ProvinceId),
        zipCode: accountDetails.Zipcode
    };
    return {
        isMultiLocationAccount,
        accountId,
        address: billingAddressObject,
        products:  {
            serviceDetails: [
                {
                    productRatePlanId,
                    quantity: 1,
                    configurationDetails: []
                }
            ],
            shipmentDetails: []
        },
        paymentMethodId
    };
};

export { getDefaultPaymentMethod, getBrandCatalogRatePlanId, getCampaignCatalogRatePlanId, buildBillingObject };